/**
 * Datos de la app en este dispositivo, por persona. Si en el mismo navegador entra otra cuenta, se borra antes lo
 * de la anterior (copia del libro y cambios pendientes): nadie ve lo de otro.
 */
import { indexedDbCache } from './indexeddb-cache.js';

const MARK = 'sut-user';

/** Huella de la cuenta (no se guarda el email en claro). */
async function markOf(email: string): Promise<string> {
  const h = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(email.trim().toLowerCase()));
  return [...new Uint8Array(h)].map(b => b.toString(16).padStart(2, '0')).join('');
}

/** Borra todo lo de la app en este dispositivo: copia del libro, cambios pendientes y lo guardado en el navegador. */
export async function wipeDevice(): Promise<void> {
  await indexedDbCache.clear();
  try { Object.keys(localStorage).filter(k => k.startsWith('sut-')).forEach(k => localStorage.removeItem(k)); } catch { /* sin almacenamiento */ }
}

/**
 * Al entrar: si el dispositivo tenía datos de otra cuenta, se borran. Devuelve true si se borró algo.
 * (Un dispositivo sin marca es de antes de que hubiera varios usuarios: se queda con quien entra.)
 */
export async function claimDevice(email: string): Promise<boolean> {
  if (!email) return false;
  const mark = await markOf(email);
  let prev: string | null = null;
  try { prev = localStorage.getItem(MARK); } catch { /* sin almacenamiento */ }
  const other = !!prev && prev !== mark;
  if (other) await wipeDevice();
  try { localStorage.setItem(MARK, mark); } catch { /* sin almacenamiento */ }
  return other;
}
